import useVerticalBreakpoint from "./useVerticalBreakpoint";

const useScreenOffset = () => {
  // const isLarge  = useVerticalBreakpoint(1800)
  //
  // return isLarge ? 40 : 20;
  return 40;
}

export default useScreenOffset;import useVerticalBreakpoint from "./useVerticalBreakpoint";

const useScreenOffset = () => {
  // const isLarge  = useVerticalBreakpoint(1800)
  //
  // return isLarge ? 40 : 20;
  return 40;
}

export default useScreenOffset;